import { Tooltip } from "components";
import { InfoMessage } from 'components';
import { bool } from "prop-types";
import { ReactComponent as Info } from 'assets/icons/info-icon.svg';
import Label from 'components/fieldLabel';

export const content = (ownerStatus, ameaMember, residence, legalChildren) =>
  [
    !(ownerStatus === 'ownerStatusOwner' && residence) && {
      label: <Label 
        label='Υπεύθυνη Δήλωση De Minimis Ιδιοκτήτη'
        asterisk={true}
      />,
      fileCode: 'benDocDeminimis',
      id: 'benDocDeminimis',
      fileLimit: 10,
      required: true
    },
    ownerStatus !== 'ownerStatusOwner' && {
      label: <Label 
        label="Υπεύθυνη Δήλωση Συναίνεσης του Ιδιοκτήτη"
        asterisk={ownerStatus !== 'ownerStatusOwner'}
      />,
      fileCode: 'benCompl',
      id: 'benCompl',
      fileLimit: 10,
      required: ownerStatus !== 'ownerStatusOwner'
    },
    ameaMember && {
      label: <div style={{display:'flex', alignItems: 'center'}}>
        <Label 
          label="Στοιχεία Πιστοποιητικών Αναπηρίας"
          asterisk={ameaMember}
        />
        <InfoMessage
          infoMessage={'Στοιχεία πιστοποιητικών αναπηρίας που παρέχονται μέσω προσκόμισης αντίστοιχης γνωμάτευσης ή πιστοποιητικού από υγειονομική επιτροπή πιστοποίησης αναπηρίας ή άλλη αρμόδια αρχή, η οποία κατά το νόμο εξακολουθεί να ασκεί τις αρμοδιότητές της καθώς επίσης το έγγραφο θα πρέπει να είναι σε ισχύ κατά την ημερομηνία της υποβολής.'}
          overlayClassName={'multiline-info-message'}
        />
      </div>,
      fileCode: 'benDisability',
      id: 'benDisability',
      fileLimit: 10,
      multiple: true,
      required: ameaMember
    },
    {
      label: <Label 
        label="Λογαριασμός Παρόχου Ηλ. Ενέργειας (Τελευταίου 2μήνου)"
        asterisk={true}
      />,
      fileCode: 'benElBill',
      id: 'benElBill',
      fileLimit: 10,
      required: true,
      multiple: true
    },
    Number(legalChildren) >= 3 && { 
      label: <Label 
        label="Πιστοποιητικό Οικογενειακής Κατάστασης"
        asterisk={true}
      />,
      fileCode: 'benFamStatus',
      id: 'benFamStatus',
      fileLimit: 10,
      required: true
    },
    (ownerStatus !== 'ownerStatusOwner' && ownerStatus !== 'ownerStatusFreeConcession') && {
      label: <div style={{display:'flex', alignItems: 'center'}}>
        <Label 
          label="Μισθωτήριο Ακινήτου"
          asterisk={true}
        />
        <InfoMessage
          infoMessage={'Δήλωση πληροφοριακών στοιχείων μίσθωσης ακίνητης περιουσίας.'}
          overlayClassName={'multiline-info-message'}
        />
      </div>,
      fileCode: 'benRental',
      id: 'benRental',
      fileLimit: 10,
      required: true
    },
    {
      label: <Label 
        label="Ε1"
        asterisk={true}
      />,
      fileCode: 'benE1',
      id: 'benE1',
      fileLimit: 10,
      required: true
    },
    {
      label: <Label 
        label="Λοιπά Έγγραφα"
        asterisk={false}
      />,
      fileCode: 'benOtherDocs',
      id: 'benOtherDocs',
      multiple: true,
      fileLimit: 10
    },
  ].filter(item => item);